import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  SR_RFQ_LIST,
  SR_RFQ_ROW_DATA,
  SR_Q_VENDORS_LIST,
  SR_QUOTATION_ADD,
  SR_QUOTATION_LIST,
  Q_SR_MODEL_LIST_OPEN,
  SR_QOUTATION_DATA,
  SRQ_FILTERS_SHOW_RIGHT_SIDEBAR,
  SR_FILTERS_HIDE_RIGHT_SIDEBAR,
  RFQ_SR_FILTERS_LIST,
  SR_MR_CODE_DETAILS,
  SR_PI_CODE_DETAILS,
  MR_SR_ITEM_IMAGES,
  // RFQ_SR_FILTERS_LIST_SUCCESS,
} from "./actionTypes";
import {
  apiError,
  getRFQListSuccessful,
  getRFQRequestdataSuccessful,
  getQuotationtVendorsList,
  QuotationtVendorsListSuccessful,
  QuotationtListSuccessful,
  QuotationDatasuccessfull,
  getRFQFilterListSuccessful,
  getMRCodeDetailsSuccessful,
  getPICodeDetailsSuccessful,
  getMRItemImgesSuccessful,
} from "./actions";

import {
  postAdd,
  getList,
  getParamsList,
  postEdit,
  // postDelete,
} from "../../helpers/Helper";
import swal from "sweetalert";
import Swal from "sweetalert2";

function* getRFQList() {
  try {
    const response = yield call(
      getList,
      "/servicerequestforquotation/Quotation/list",
      {}
    );
    yield put(getRFQListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getRFQfilterList() {
  try {
    const response = yield call(getList, "/requestforquotation/All/list", {});
    yield put(getRFQFilterListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getRFQRowdata({ payload: { rfqId, byVendor } }) {
  try {
    const response = yield call(getList, "/servicerequestforquotation/" + rfqId, {});
    yield put(getRFQRequestdataSuccessful(response));
    if (!byVendor) {
      yield put(getQuotationtVendorsList(rfqId));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}
function* GetVendorData({ payload: { rfqId } }) {
  try {
    const response = yield call(getList, "/servicequotation/vendorbysrfq/" + rfqId, {});
    yield put(QuotationtVendorsListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddQoutation({ payload: { data, qoutId, history } }) {
  try {
    if (qoutId === 0) {
      var response = {};
      if (data.token !== "") {
        response = yield call(postAdd, "/servicequotation/add/vendor", data);
      } else {
        response = yield call(postAdd, "/servicequotation/", data);
      }

      if (response.status === 201) {
        swal(" Your Quotation Added Successfully.!", {
          icon: "success",
        });
        if (data.token !== "") {
          localStorage.removeItem("access_token");
          window.location.href = "/vendorlogin/" + data.token;
        } else {
          history.push("/srquotationdashboard");
        }
      } else {
        swal("Sorry! Unable to add quotation. Please try again!", {
          icon: "error",
        });
      }
    } else {
      delete data.vendor_id;
      const response = yield call(postEdit, "/servicequotation/" + qoutId, data);

      if (response.status === 200) {
        swal("Your quotation Edited Successfully.!", {
          icon: "success",
        });
        history.push("/srquotationdashboard");
      } else {
        swal("Sorry! Unable to edit quotation. Please try again!", {
          icon: "error",
        });
      }
    }
  } catch (error) {
    if (data.token !== "") {
      Swal.fire({
        icon: "error",
        text: "Quotation already Submited! ",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/vendorlogin/" + data.token;
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        text: "Please Try Again! ",
      });
    }

    yield put(apiError(error));
  }
}
function* getSRQuotationList({ payload: { data } }) {
  console.log("hello World")
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/servicequotation/list", params);

    yield put(QuotationtListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getQuotationRowdata({ payload: { qId } }) {
  try {
    const response = yield call(getList, "/servicequotation/" + qId, {});
    yield put(
      QuotationDatasuccessfull({
        response: {
          ...response,

          vendor_id: response.vendor ? response.vendor.id : 0,
          vendLabel: response.vendor ? response.vendor.name : "",
        },
      })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getMRCodeDetails({ payload: { ItemId } }) {
  try {
    const response = yield call(
      getList,
      "/servicequotation/srcodebyqitem/" + ItemId,
      {}
    );
    yield put(getMRCodeDetailsSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getPICodeDetails({ payload: { ItemId } }) {
  try {
    const response = yield call(
      getList,
      "/servicequotation/sicodebyqitem/" + ItemId,
      {}
    );
    yield put(getPICodeDetailsSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getRFQMRItemImges({ payload: { rfqItemId } }) {
  try {
    const response = yield call(
      getList,
      "/requestforquotation/mrcodebyrfqitem/" + rfqItemId,
      {}
    );
    yield put(getMRItemImgesSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
  switch (action) {
    case "add":
      if (document.body) document.body.classList.add(cssClass);
      break;
    case "remove":
      if (document.body) document.body.classList.remove(cssClass);
      break;
    default:
      if (document.body) document.body.classList.toggle(cssClass);
      break;
  }

  return true;
}
function* FilterShowRightSidebar() {
  try {
    yield call(manageBodyClass, "filters-right-bar-enabled");
  } catch (error) {}
}
function* FilterHideRightSidebar() {
  try {
    yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
  } catch (error) {}
}
export function* watchgetRFQList() {
  yield takeEvery(SR_RFQ_LIST, getRFQList);
}
export function* watchgetRFQRowdata() {
  yield takeEvery(SR_RFQ_ROW_DATA, getRFQRowdata);
}
export function* watchQoutationAdd() {
  yield takeEvery(SR_QUOTATION_ADD, AddQoutation);
}
export function* watchgetSRQuotationList() {
  yield takeEvery(SR_QUOTATION_LIST, getSRQuotationList);
}
export function* watchmodellist() {
  yield takeEvery(Q_SR_MODEL_LIST_OPEN, getQuotationRowdata);
}
export function* watchQuotationData() {
  yield takeEvery(SR_QOUTATION_DATA, getQuotationRowdata);
}
export function* watchGetVendorData() {
  yield takeEvery(SR_Q_VENDORS_LIST, GetVendorData);
}

export function* watchFilterShowRightSidebar() {
  yield takeEvery(SRQ_FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
  yield takeEvery(SR_FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchgetRFQFilterList() {
  yield takeEvery(RFQ_SR_FILTERS_LIST, getRFQfilterList);
}
export function* watchgetMRCodeDetails() {
  yield takeEvery(SR_MR_CODE_DETAILS, getMRCodeDetails);
}
export function* watchgetPICodeDetails() {
  yield takeEvery(SR_PI_CODE_DETAILS, getPICodeDetails);
}
export function* watchgetMRItemData() {
  yield takeEvery(MR_SR_ITEM_IMAGES, getRFQMRItemImges);
}
function* SRQuotationSaga() {
  yield all([
    fork(watchgetRFQList),
    fork(watchgetRFQRowdata),
    fork(watchGetVendorData),
    fork(watchQoutationAdd),
    fork(watchgetSRQuotationList),
    fork(watchmodellist),
    fork(watchQuotationData),

    fork(watchFilterShowRightSidebar),
    fork(watchfilterHideRightSidebarr),
    fork(watchgetRFQFilterList),
    fork(watchgetMRCodeDetails),
    fork(watchgetPICodeDetails),
    fork(watchgetMRItemData),
  ]);
}

export default SRQuotationSaga;
